module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value.length < 1
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "tags": _vm.AllowCustomValues,
      "multiple": true,
      "placeholder": ' ',
      "disabled": _vm.readOnly,
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  }, _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  }), 0)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d833953","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperManagement/FormComponents/MultiSelectInput.vue
// module id = 1653
// module chunks = 1